// extracted by mini-css-extract-plugin
export default {"LoadText":"loadText_LoadText__uVt83","Light":"loadText_Light__xZZ0o"};